
<template>
  <!--报名详情-->
  <div class="advanced-form">
    <a-form layout="vertical">
      <div class="card">
        <div class="card-head">
          <h3>基本信息</h3>
        </div>
        <div class="card-body">
        <a-row type="flex">
          <a-col :span="8">
           <a-form-item class="value-indent" label="昵称">
              <span class="ant-form-text">{{detailInfo.nickName}}</span>
            </a-form-item>
          </a-col>
           <a-col :span="8">
              <a-form-item class="value-indent" label="手机号">
                <span class="ant-form-text">{{detailInfo.mobile}}</span>
              </a-form-item>
           </a-col>

             <a-col :span="8">
                <a-form-item class="value-indent" label="状态">
                  <span class="ant-form-text">{{detailInfo.applyStatusDesc}}</span>
                </a-form-item>
             </a-col>

            <a-col :span="8">
              <a-form-item class="value-indent" label="报名时间">
                <span class="ant-form-text">{{detailInfo.createTime}}</span>
              </a-form-item>
            </a-col>

        </a-row>
      </div>
        <div class="card-body" style="display:none">
          <a-row type="flex">
            <a-col v-for="(item, index) of baseInfo" :key="index" :span="8">
              <a-form-item class="value-indent" :label="item.label">
                <!-- <div class="pic-box absolute" v-if="item.key==='avatarUrl'">
                  <img :src="item.value" alt="">
                </div> -->
                <span class="ant-form-text">{{item.value}}</span>
              </a-form-item>
            </a-col>
          </a-row>
        </div>
      </div>
    </a-form>

    <div class="card">
      <div class="card-head">
        <h3>报名信息</h3>
      </div>
      <div class="card-body">
        <a-row type="flex">
          <a-col v-for="(item, index) of applyInfos" :key="index" :span="8">
            <a-form-item class="value-indent" :label="item.title" v-if="item.mark == 'receiveAddr'">
              <span class="ant-form-text">
                {{addrObj.name}}<br/>{{addrObj.mobile}}<br/>{{addrObj.area}}{{addrObj.address}}
              </span>
            </a-form-item>
            <a-form-item class="value-indent" :label="item.title" v-else-if="item.mark == 'sex'">
              <span class="ant-form-text" v-if="item.value =='1'">男</span>
              <span class="ant-form-text" v-else-if="item.value =='2'">女</span>
              <span class="ant-form-text" v-else></span>
            </a-form-item>
            <a-form-item class="value-indent" :label="item.title" v-else>
              <span class="ant-form-text">{{item.value}}</span>
            </a-form-item>
          </a-col>
        </a-row>
      </div>
      <div class="card-head">
        <h3>项目信息</h3>
      </div>
      <div class="card-body">
        <x-tabula
          ref="table"
          :searchList="[]"
          rowKey="householder_info_id"
          :columns="columns"
          :dataSource ="detailInfo.goods"
          :paginationParam="false"
          :rowSelection="false"
        >
        <!-- :listApi="listApi" -->
          <template slot="opt_expireTime" slot-scope="{row}">
            <span>{{row.expireTime | foreverTime}}</span>
          </template>
          <template slot="opt_goodsFee" slot-scope="{row}">
            <span>{{row.goodsFee | toMoney}}</span>
          </template>
          <template slot="opt_price" slot-scope="{row}">
            <span>{{row.price | toMoney}}</span>
          </template>
        </x-tabula>
      </div>
    </div>

      <div class="card" v-show="detailInfo.deliveryType ==2">
        <div class="card-head">
          <h3>物流信息</h3>
        </div>
        <div class="card-body">
          <a-row type="flex">
            <a-col v-bind="$store.state.advanced_colWidth">
              <a-form-item class="value-indent" label="送货方式">
                <span  class="ant-form-text">{{detailInfo.deliveryTypeDesc}}</span>
              </a-form-item>
            </a-col>
            <a-col v-bind="$store.state.advanced_colWidth">
              <a-form-item class="value-indent" label="物流公司名称">
                <span  class="ant-form-text">{{ detailInfo.logisticsName }}</span>
              </a-form-item>
            </a-col>
            <a-col v-bind="$store.state.advanced_colWidth">
              <a-form-item class="value-indent" label="物流单号">
                <span  class="ant-form-text">{{detailInfo.logisticsNo}} <a v-show = 'detailInfo.logisticsNo' @click = 'showLogisticsInfo'>  查看物流信息</a></span>
              </a-form-item>
            </a-col>
          </a-row>
        </div>

      </div>
      <div class="card">
        <div class="card-head">
          <h3>订单信息</h3>
        </div>
        <div class="card-body">
          <a-row type="flex">
            <a-col v-bind="$store.state.advanced_colWidth">
              <a-form-item class="value-indent" label="订单号">
                <span  class="ant-form-text">{{ detailInfo.activityApplyId }}</span>
              </a-form-item>
            </a-col>
            <a-col v-bind="$store.state.advanced_colWidth">
              <a-form-item class="value-indent" label="下单时间">
                <span  class="ant-form-text">{{ detailInfo.createTime }}</span>
              </a-form-item>
            </a-col>
            <a-col v-bind="$store.state.advanced_colWidth">
              <a-form-item class="value-indent" label="付款时间">
                <span  class="ant-form-text">{{detailInfo.payTime}}</span>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row type="flex">
            <a-col v-bind="$store.state.advanced_colWidth">
              <a-form-item class="value-indent" label="商品总计">
                <span  class="ant-form-text">￥{{detailInfo.totalGoodsFee}}</span>
              </a-form-item>
            </a-col>
            <a-col v-bind="$store.state.advanced_colWidth" v-if="detailInfo.type == 2">
              <a-form-item class="value-indent" label="运费">
                <span  class="ant-form-text">￥{{detailInfo.freight}}</span>
              </a-form-item>
            </a-col>
            <a-col v-bind="$store.state.advanced_colWidth">
              <a-form-item class="value-indent" label="总价">
                <span  class="ant-form-text">￥{{detailInfo.totalFee}}</span>
              </a-form-item>
            </a-col>
            <a-col v-bind="$store.state.advanced_colWidth" v-if="detailInfo.type != 2">
              <a-form-item class="value-indent" label="平台优惠">
                <span  class="ant-form-text">￥{{detailInfo.platformVoucherAmount}}</span>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row type="flex">
            <a-col v-bind="$store.state.advanced_colWidth" v-if="detailInfo.type == 2">
              <a-form-item class="value-indent" label="平台优惠">
                <span  class="ant-form-text">￥{{detailInfo.platformVoucherAmount}}</span>
              </a-form-item>
            </a-col>
            <a-col v-bind="$store.state.advanced_colWidth">
              <a-form-item class="value-indent" label="实付">
                <span  class="ant-form-text">￥{{detailInfo.payFee}}</span>
              </a-form-item>
            </a-col>
          </a-row>
        </div>
      </div>
      <logisticsInfo ref='logisticsInfoModel'></logisticsInfo>
  </div>
</template>

<script>
import logisticsInfo from '../../local/component/logisticsInfo.vue';
export default {
  name: 'memberDetail',
  components: {logisticsInfo},
  data () {
    return {
      addrObj: {}, // 报名详情收获地址 Json
      applyInfos: [],
      detailInfo: {
        logisticsNo: undefined,
        logisticsCode: undefined
      },
      detail: {},
      listApi: {
        url: '',
        resHandle: '',
        searchHandle: ''
      },
      loginListApi: {
        url: '',
        resHandle: '',
        searchHandle: ''
      },

      baseInfo: [
        {key: '', label: '', value: ''}

      ],
      columns: [
        { title: '商品名称', dataIndex: 'title', align: 'left', width: '' },
        { title: '单价', dataIndex: 'price', align: 'left', width: '', scopedSlots: {customRender: 'price'}},
        { title: '数量(件)', dataIndex: 'goodsNumber', align: 'left', width: '' },
        { title: '金额', dataIndex: 'goodsFee', align: 'left', width: '', scopedSlots: {customRender: 'goodsFee'}}
      ],

      tableData: []
    };
  },
  filters: {
    tofloor (val) {
      if (val != null) {
        return Number(val).toFixed(2);
      } else {
        return '';
      }
    },
    toMoney (val) {
      if (val != null) {
        return '￥' + Number(val).toFixed(2);
      } else {
        return '';
      }
    }
  },
  created () {
    // this.listApi.url = `/member/rooms/${this.$route.query.id}`;
    // this.loginListApi.url = `/member/logs/${this.$route.query.id}`;
    this.getDetail();
  },
  beforeRouteEnter (to, from, next) {
    next();
    setTimeout(() => {
      document.getElementsByClassName('layout-content')[0].style.padding = '0px';
      document.getElementsByClassName('layout-content')[0].style.backgroundColor = 'transparent';
    }, 0);
  },
  beforeRouteLeave (to, from, next) {
    document.getElementsByClassName('layout-content')[0].style.padding = '16px';
    document.getElementsByClassName('layout-content')[0].style.backgroundColor = '#fff';
    next();
  },
  mounted () {
  },
  methods: {
    showLogisticsInfo () {
      if (this.detailInfo.logisticsCode && this.detailInfo.logisticsNo) {
        this.$refs.logisticsInfoModel.show(this.detailInfo.logisticsCode, this.detailInfo.logisticsNo);
      }
    },
    getDetail () {
      this.$get({
        url: `/activity/apply/${this.$route.query.id}`, // ${this.$route.query.id} 1549329490960842753
        params: {}
      }).then(({data}) => {
        this.detailInfo = data;
        for (let item of data.applyInfo) {
          if (item.mark == 'receiveAddr' && typeof (item.value) === 'object') {
            this.addrObj = JSON.parse(item.value);
          } else if (item.mark == 'receiveAddr') {
            try {
              this.addrObj = JSON.parse(item.value);
            } catch (error) {
              this.addrObj = item.value;
            }
          }
        }
        this.applyInfos = data.applyInfo;
      });
    }
  }
};
</script>
<style scoped >
/* ::v-deep  */

  .layout-content{
    padding:0;
    background: transparent !important;
  }
  .card{
    /* border:1px solid red; */
     /* background: red !important; */
    margin-bottom:24px;
    /* border-bottom:24px solid #ccc; */
  }
  :deep .advanced-form .card:not(.list-card) {
      margin-bottom: 124px;
  }
  ::v-deep .ant-table-tbody tr:last-child{font-weight: bold;color:black}
</style>
